import React from 'react'

import { connect } from "react-redux"

import { Form } from 'react-form'

import FieldEditor from '../components/common/FieldEditor'
import FieldInputText from '../components/common/FieldInputText'
import FieldInputTextarea from '../components/common/FieldInputTextarea'

import { Toolbar } from 'primereact/toolbar'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { Dropdown } from 'primereact/dropdown'

import { SYS_PARAM_HTML, SYS_PARAM_TEXT, SYS_PARAM_NUMBER } from '../js/const'

import * as appActionCreators from "../actionCreators/app"
import * as systemParameterActionCreators from "../actionCreators/systemParameter"

import '../css/system-parameter.css'

class SystemParameter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedParameter: {}
    }

    // need to use a ref for the Editor because it seems to only set the value in componentDidMount
    // since we could potentially switch between two parameters that have an editor then it wouldn't get the value of the last parameter
    // there is also an issue with react form where the value will be blank initially and then it will be loaded so it only shows a blank value
    this.parameterValueEditor = React.createRef()
  }

  componentDidMount() {
    //is invoked immediately after a component is mounted. 
    //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
    this.props.setLoading(true)
      .then(() => this.props.getSystemParameters())
      .then(() => this.props.setLoading(false))
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.props.history.push('/error/401')
          this.props.setLoading(false)
        } else {
          this.props.handleError(error)
            .then(() => this.props.setLoading(false))
        }
      })
  }

  // this function will be called when the form is submitted successfully
  // the client object passed is in the same structure as the object bound to <Form> values property
  // the object will have been updated based on user input
  saveSystemParameter = systemParameter => {
    this.props.setLoading(true)
      .then(() => this.props.updateSystemParameter(systemParameter))
      .then(response => {
        // set response in store so global response component can handle response
        /*
            response json structure is:
            {
                "$id":"1",
                "SuccessOutput":null,
                "Success":false,
                "ErrorMessages":{
                    "$id":"2",
                    "$values":[
                        "Name is required"
                    ]
                },
                "WarningMessages":{
                    "$id":"3",
                    "$values":[

                    ]
                }
            }
        */
        this.props.setAjaxResponse(response)
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  parameterChanged = e => {
    this.setState({ selectedParameter: e.value }, () => { 
      // if loading a parameter with an editor then update the value based on the updated parameter
      if (this.parameterValueEditor.current) {
        this.parameterValueEditor.current.quill.pasteHTML(e.value.ParameterValue)
      }
    })    
  }

  render() {
    let systemParameters = this.props.systemParameter.systemParameters
    let selectedParameterType = this.state.selectedParameter.ParameterTypeLookup ? this.state.selectedParameter.ParameterTypeLookup.SystemCode : ''
    return (
      <div className={"system-parameter-details"}>
        <Card title={"Maintain System Parameters"}>
          <div className="p-grid">
            <div className="p-col-12 field-label-container">
              <label>
                System Parameter Name
              </label>
            </div>
            <div className="p-col-12 field-element-container">
              <Dropdown value={this.state.selectedParameter} options={systemParameters} style={{ width: '100%' }}
                onChange={e => { this.parameterChanged(e) }}
                optionLabel="ParameterName" dataKey="ParameterName"
              />
            </div>
            {/* values sets the form state. I'm binding to the props which is linked redux so we can update the store and the form will be reflected
                   this is useful when needed to clear the form or populating the form from another component
                   onSubmit is called when the form has been submitted and has passed validation
                   formApi properties can be found at https://react-form.js.org/#/*/}
            <Form values={this.state.selectedParameter} onSubmit={this.saveSystemParameter}>
              {formApi => {
                let validationRules = this.state.selectedParameter.ValidationRules ? this.state.selectedParameter.ValidationRules.$values : []
                return (
                  <React.Fragment>
                    <div className="p-col-12 p-md-12 p-lg-12">
                      <FieldInputTextarea rows={3} field={"ParameterDesc"} label={"Parameter Description"} tabindex="0" aria-label={"Parameter Description"} validationRules={validationRules} showAsTextOnly={false} />
                    </div>
                    {selectedParameterType === SYS_PARAM_NUMBER && <div className="p-col-12">
                      <FieldInputText field={"ParameterValue"} label={"Value"} keyfilter="int" tabindex="0" aria-label={"Value"} validationRules={validationRules} showAsTextOnly={false} />
                    </div>}
                    {selectedParameterType === SYS_PARAM_TEXT && <div className="p-col-12">
                      <FieldInputText field={"ParameterValue"} label={"Value"}  tabindex="0" aria-label={"Value"} validationRules={validationRules} showAsTextOnly={false} />
                    </div>}
                    {selectedParameterType === SYS_PARAM_HTML && <div className="p-col-12">
                      <FieldEditor editorRef={this.parameterValueEditor} field={"ParameterValue"} label={"Value"}  tabindex="0" aria-label={"Value"} validationRules={validationRules} showAsTextOnly={false} />
                    </div>}
                    {this.state.selectedParameter.SystemParameterId && <Toolbar>
                      <div className="p-toolbar-group-left">
                        <Button label="Save" icon="pi pi-check" onClick={formApi.submitForm} />
                      </div>
                    </Toolbar>}
                  </React.Fragment>
                )
              }
              }
            </Form>
          </div>
        </Card >
      </div>
    )
  }
}

const mapStateToProps = ({ systemParameter }) => {
  return { systemParameter }
}

// this is how to combine actions available
const actionCreators = {
  ...appActionCreators,
  ...systemParameterActionCreators
}

export default connect(mapStateToProps, actionCreators)(SystemParameter)


// WEBPACK FOOTER //
// ./src/container/SystemParameter.js